export default __webpack_public_path__ + "static/media/Rodolfo3.f8070fb8.png";